export const NOTIFICATION_LINK_TITLE = 'View item';
export const NOTIFICATION_ERROR_MESSAGE = 'Failed to fetch notifications.';
